import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.css';
import completeIcon from 'assets/progress-complete.svg';
import { OrderBarContent } from 'services/content';

const orderDisplay = (currentProgress, comparison, titleName) => {
  return currentProgress > comparison ? (
    <div className={styles.orderContainer}>
      <img className={styles.completeIcon} src={completeIcon} alt="complete icon" />
      <p className={styles.orderTitle}>{titleName}</p>
    </div>
  ) : (
    <div className={styles.orderContainer}>
      <div className={`${styles.dot} ${currentProgress === comparison ? styles.dot__active : styles.dot__inactive}`} />
      <p className={`${styles.orderTitle} ${currentProgress === comparison ? styles.orderTitle__bold : ''}`}>
        {titleName}
      </p>
    </div>
  );
};

const OrderBar = ({ currentProgress }) => {
  return (
    <div className={styles.orderBar}>
      <div className="coop-l-container">
        <div className={styles.orderBarinner}>
          {orderDisplay(currentProgress, 0, OrderBarContent.yourOrderText)}
          <div className={styles.line} />
          {orderDisplay(currentProgress, 1, OrderBarContent.basketText)}
          <div className={styles.line} />
          {orderDisplay(currentProgress, 2, OrderBarContent.confirmation)}
        </div>
      </div>
    </div>
  );
};

OrderBar.propTypes = {
  currentProgress: PropTypes.number.isRequired,
};

export default OrderBar;
